import styles from "./WaysToStyle.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import NewPill from "../pills/newPill/NewPill";
import WaysToStyleCarousel from "./WaysToStyleCarousel";
import { useWaysToStyle } from "../../context/waysToStyle/WaysToStyleContext";

const WaysToStyle: React.FC = () => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  const stylingLooksData = useWaysToStyle();

  if (
    stylingLooksData.shouldShowWaysToStyle === false ||
    stylingLooksData?.stylingLooks?.length === 0
  ) {
    return null;
  }

  return (
    <section
      data-testid="waysToStyleSection"
      className={styles.section}
      aria-label={getTranslation("pdp_associated_buy_the_look_title")}
    >
      <div className={styles.containerHeader}>
        <NewPill text={getTranslation("generic_onboarding_feature_new_tag")} />
        <h2 className={styles.title}>
          {getTranslation("pdp_associated_buy_the_look_title")}
        </h2>
        <p className={styles.subtitle}>
          {getTranslation("pdp_ways_to_style_subtitle")}
        </p>
      </div>
      <div
        data-testid="waysToStyleCarouselContainer"
        aria-label={getTranslation("pdp_buy_the_look_carousel_accessibility")}
        className={styles.waysToStyleCarouselContainer}
      >
        <WaysToStyleCarousel stylingLooks={stylingLooksData.stylingLooks} />
      </div>
    </section>
  );
};

export default WaysToStyle;
